import { StyledDialog } from "@Components/game/common/dialog/styled-components";
import { Box, Dialog, styled } from "@mui/material";
import type { Theme } from "@mui/material/styles";

const noteTypography = {
  fontStyle: "normal",
  letterSpacing: 0,
} as const;

const mainHeadingTypography = (theme: Theme) => ({
  ...theme.typography.text4xl800,
  ...noteTypography,
  textAlign: "center" as const,
  lineHeight: "40px",
});

export const HealthNoteDialog = styled(Dialog)(({ theme }) => ({
  zIndex: 10_001,
  "&& .MuiDialog-paperFullScreen": {
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    minWidth: 0,
    maxWidth: "none",
    maxHeight: "none",
    margin: 0,
    border: 0,
    borderRadius: 0,
    backgroundColor: theme.palette.dsBase.v100,
    backgroundImage: "none",
    backdropFilter: "none",
    color: theme.palette.dsBase.v200,
    padding: theme.spacing(4),
    overflow: "hidden",
    [theme.breakpoints.up("sm")]: { padding: theme.spacing(8) },
  },
}));

export const HealthNoteLayout = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.5),
  width: "100%",
  maxWidth: 960,
  maxHeight: "100%",
  minHeight: 0,
  margin: "auto",
}));

export const HealthNoteTitle = styled("h1")(({ theme }) => ({
  ...mainHeadingTypography(theme),
  margin: 0,
  flexShrink: 0,
  overflowWrap: "anywhere",
}));

export const HealthNoteContent = styled(Box)(({ theme }) => ({
  ...theme.typography.textLg400,
  ...noteTypography,
  textAlign: "left",
  minHeight: 0,
  overflowY: "auto",
  overflowWrap: "anywhere",
  "& p, & ul, & ol, & blockquote": { margin: "0 0 1em" },
  "& > p, & > ul, & > ol, & > blockquote": { marginBottom: theme.spacing(5) },
  "& > p:first-child": { textAlign: "center", marginBottom: theme.spacing(6) },
  "& ul, & ol": { paddingLeft: "1.5em" },
  "& li + li": { marginTop: "0.5em" },
  "& h1": { ...mainHeadingTypography(theme), margin: theme.spacing(0, 0, 1.5) },
  "& h2, & h3, & h4": { ...theme.typography.textLg700, margin: theme.spacing(0, 0, 1) },
  "& a": { color: theme.palette.dsBase.v200, textDecoration: "underline" },
  "& > :last-child": { marginBottom: 0 },
}));

export const HealthNoteReleaseDialog = styled(StyledDialog)(({ theme }) => ({
  zIndex: 10_001,
  "&& .MuiDialog-paper": {
    boxSizing: "border-box",
    width: "800px",
    minWidth: 0,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "90%",
    backgroundColor: theme.palette.dsSurface.v100,
    backgroundImage: "none",
    backdropFilter: "none",
    overflow: "hidden",
  },
}));

export const HealthNoteReleaseLayout = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.5),
  padding: theme.spacing(6, 0),
  minHeight: 0,
  overflow: "hidden",
}));

export const HealthNoteReleaseTitle = styled(HealthNoteTitle)(({ theme }) => ({
  color: theme.palette.dsBase.v200,
  padding: theme.spacing(0, 6),
}));

export const HealthNoteReleaseContent = styled(HealthNoteContent)(({ theme }) => ({
  color: theme.palette.dsBase.v200,
  minHeight: 0,
  overflowY: "auto",
  overflowWrap: "anywhere",
  padding: theme.spacing(0, 6),
}));
